import { Fragment } from "react";
import usePage from "../../hooks/usePage";
import Footer from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import Counter from "./components/Counter/Counter";
import CTA from "./components/CTA/CTA";
import DecorationImage from "./components/DecorationImage/DecorationImage";
import FAQ from "./components/FAQ/FAQ";
import Hero from "./components/Hero/Hero";
import Partners from "./components/Partners/Partners";
import PricingExamples from "./components/PricingExamples/PricingExamples";
import Services from "./components/Services/Services";
import Slogan from "./components/Slogan/Slogan";

export default function DigikalaRedesign() {
  const { pageSliders, pageImage, pageText, pageBody } = usePage();

  return (
    <Fragment>
      <Menu />

      {pageSliders}

      <main className="flex-grow-1 py-4">
        {pageSliders}

        <div>
          <Hero hero={pageBody.hero[0]} />

          <Partners
            title={pageBody.titles[0].partner}
            partners={pageBody.partners}
          />

          <Services
            title={pageBody.titles[0].service}
            services={pageBody.services}
            tick={pageBody.servicesImg[0]}
          />

          <PricingExamples
            title={pageBody.titles[0].price}
            menus={pageBody.pricesMenus}
          />

          <Slogan
            title={pageBody.slogan[0].title}
            text={pageBody.slogan[0].text}
          />

          <CTA
            text={"ویدیو آموزش پنل دیجی‌کالا"}
            link="/developers/digikala-panel"
          />

          <Counter counters={pageBody.counter} />

          <DecorationImage
            imgSrc={pageBody.titles[0].imgUrl}
            imgAlt={pageBody.titles[0].altImg}
          />

          <FAQ title={pageBody.titles[0].faq} faq={pageBody.faq} />

          {pageText}

          {pageImage}
        </div>
      </main>

      <Footer />
    </Fragment>
  );
}
